"use client"

import clsx from "clsx"
import React from "react"

import LoadingSpinner from "./LoadingSpinner"

interface SubmitButtonProps {
  text: React.ReactNode
  isLoading: boolean
  disabled: boolean
  onClick?: () => void
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ text, isLoading, disabled, onClick }) => {
  return (
    <button
      type="submit"
      form="native-form"
      disabled={disabled || isLoading}
      onClick={onClick}
      className={clsx(
        "w-full rounded-full py-4 font-medium",
        "font-manrope",
        "text-[14px]",
        "border-none transition-colors duration-300",
        !disabled || isLoading ? "bg-nelo-blue text-white hover:bg-nelo-blue-hover" : "bg-[#D9D9D9] text-nelo-black"
      )}
    >
      {isLoading ? (
        <span className="inline-flex w-full items-center justify-center">
          <LoadingSpinner />
        </span>
      ) : (
        <>{text}</>
      )}
    </button>
  )
}

export default SubmitButton
